import { AxiosResponse } from 'axios';

import apiClient from './client';
import { ApiResponseDto } from 'interfaces/apiResponse';
import { IbanInfo } from 'interfaces/ibanInfo';

interface IbanService {
  validateIban(queryParams: any): Promise<IbanInfo>;
}

const endpoints = {
  validateIban: '/iban/validate',
};

export const ibanService: IbanService = {
  validateIban: async (queryParams?: any): Promise<IbanInfo> => {
    const response: AxiosResponse<ApiResponseDto<IbanInfo>> = await apiClient.get(endpoints.validateIban, { params: { ...queryParams } });

    if (response.data.errors) {
      throw new Error(response.data.errors!.map(error => error.message).join(', '));
    }

    return response.data.data!;
  },
};
